import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { createBuiltInColorMap } from '@atlassian/color-picker';
import { getHubDefaultParameters, HubErrorLogger, logException, ProductDependenciesContext, useHubContext } from '@atlassian/company-hub-common';
export var CommonHubExtensionsDependenciesProvider = function CommonHubExtensionsDependenciesProvider(_ref) {
  var _branding$colors;
  var children = _ref.children;
  var _useHubContext = useHubContext(),
    cloudId = _useHubContext.cloudId,
    cloudUrl = _useHubContext.cloudUrl,
    pageMediaConfig = _useHubContext.pageMediaConfig,
    hubMediaConfig = _useHubContext.hubMediaConfig,
    env = _useHubContext.env,
    branding = _useHubContext.branding;
  var hoistedProjectKey = env.hoistedProjectKey;
  var defaultParameters = getHubDefaultParameters();
  var brandBackgroundColorMap = React.useMemo(function () {
    var brandBackgroundColors = [defaultParameters.backgroundColor];
    return createBuiltInColorMap({
      knownColors: brandBackgroundColors
    });
  }, [defaultParameters]);
  var authProvider = useCallback(function () {
    return Promise.resolve({
      asapIssuer: pageMediaConfig.asapIssuer,
      token: pageMediaConfig.mediaToken,
      baseUrl: pageMediaConfig.mediaUrl
    });
  }, [pageMediaConfig]);
  var createEditorMediaProvider = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var onUploadRejection, mediaProvider;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onUploadRejection = _ref2.onUploadRejection;
            mediaProvider = {
              uploadParams: {
                collection: pageMediaConfig.mediaCollectionName,
                onUploadRejection: onUploadRejection
              },
              viewMediaClientConfig: {
                authProvider: authProvider
              },
              uploadMediaClientConfig: {
                authProvider: authProvider
              }
            };
            return _context.abrupt("return", mediaProvider);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [authProvider, pageMediaConfig]);
  var useMediaConfig = useCallback(function (_ref4) {
    var imageSrc = _ref4.imageSrc;
    return {
      authProvider: authProvider,
      collection: pageMediaConfig.mediaCollectionName,
      fileId: imageSrc
    };
  }, [authProvider, pageMediaConfig]);
  var contextValue = {
    smartCardProviderComponent: undefined,
    isTargetAudience: function isTargetAudience() {
      return false;
    },
    useSegmentationTargetGroups: function useSegmentationTargetGroups() {
      return {};
    },
    isCompanyHub: true,
    // need to pass this true to enable company hub specific extensions
    enableLinkInputInMediaPicker: true,
    cloudId: cloudId,
    cloudUrl: cloudUrl,
    hoistedProjectKey: hoistedProjectKey,
    helpCenterAri: env.helpCenterAri,
    isAdminHubAIEnabled: false,
    linkPickerConfig: {
      linkPickerPlugins: []
    },
    userId: '',
    customMediaConfig: hubMediaConfig,
    createEditorMediaProvider: createEditorMediaProvider,
    useMediaConfig: useMediaConfig,
    branding: _objectSpread(_objectSpread({}, branding), {}, {
      defaultParameters: defaultParameters,
      hideDefaultColorPalette: !!(branding !== null && branding !== void 0 && (_branding$colors = branding.colors) !== null && _branding$colors !== void 0 && _branding$colors.primary),
      brandBackgroundColorMap: brandBackgroundColorMap
    }),
    hideExtensionBorders: true,
    showConfigPreambleSupportLink: false,
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false,
    experienceStopComponent: HubErrorLogger,
    submitError: logException
  };
  return /*#__PURE__*/React.createElement(ProductDependenciesContext.Provider, {
    value: contextValue
  }, children);
};